import axios from 'axios';
import config from '@/config';
import { buildAxiosGetConfigWithRepeatedKey } from '@/features/common/utils/axiosQueryUtil';

const { iffApi } = config.ctx;

/**
 * 工具台账与借用 API 服务
 */
export const toolService = {
  /** 查询工具台账统计（总数/可用/借出中/待审批） */
  getStatistics: () => axios.get(`${iffApi}/tool/statistics`),

  /** 分页查询工具台账列表 */
  queryToolPage: (params) => axios.get(`${iffApi}/tool/page`, { params }),

  /** 新增工具 */
  saveTool: (data) => axios.post(`${iffApi}/tool/save`, data),

  /** 编辑工具 */
  updateTool: (data) => axios.post(`${iffApi}/tool/update`, data),

  /** 删除工具（逻辑删除） */
  deleteTool: (uuid) => axios.delete(`${iffApi}/tool/delete/${uuid}`),

  /** 分页查询借用记录（statusList 多值时重复 query 参数 statusList=） */
  queryBorrowPage: (inputParams = {}) =>
    axios.get(`${iffApi}/tool/borrow/page`, buildAxiosGetConfigWithRepeatedKey(inputParams, 'statusList')),

  /** 发起借用申请 */
  applyBorrow: (data) => axios.post(`${iffApi}/tool/borrow/apply`, data),

  /** 审批通过 */
  approveBorrow: (data) => axios.post(`${iffApi}/tool/borrow/approve`, data),

  /** 审批拒绝 */
  rejectBorrow: (data) => axios.post(`${iffApi}/tool/borrow/reject`, data),

  /** 借用人发起归还（using → return_pending） */
  applyReturn: (data) => axios.post(`${iffApi}/tool/borrow/apply-return`, data),

  /** 审核员确认归还 */
  confirmReturn: (data) => axios.post(`${iffApi}/tool/borrow/return`, data),

  /** 工具台账：下载导入模板 */
  downloadToolTemplate: () => axios.get(`${iffApi}/tool/getExcelMb`, { responseType: 'blob' }),

  /** 工具台账：Excel 导入 */
  importTool: (formData) =>
    axios.post(`${iffApi}/tool/importExcel`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
};
